import { InjectionToken } from '@angular/core';

import type { IReportHandler } from '../services/handlers/i-report.handler';
import type { IReportProvider } from '../services/providers/i-report.provider';

export const REPORT_HANDLER = new InjectionToken<IReportHandler>('IReportHandler');

export const REPORT_PROVIDER = new InjectionToken<IReportProvider>('IReportProvider');
